export enum EnumTraslationKeysEnum {
	ActivityLogActionTypeEnum = "ActivityLogActionTypeEnum",
	ActivityLogModuleTypeEnum = "ActivityLogModuleTypeEnum",
	ApiEnum = "ApiEnum",
	ApiRequestTypeEnum = "ApiRequestTypeEnum",
	AppointmentRecommendationEnum = "AppointmentRecommendationEnum",
	AppointmentStatusEnum = "AppointmentStatusEnum",
	AppointmentTypeGroupEnum = "AppointmentTypeGroupEnum",
	SubscriptionTypeGroupEnum = "SubscriptionTypeGroupEnum",
	AppriseApiCallModeTypeEnum = "AppriseApiCallModeTypeEnum",
	AppriseApiCallSubTypeEnum = "AppriseApiCallSubTypeEnum",
	AppriseApiCallTypeEnum = "AppriseApiCallTypeEnum",
	AppriseRequestTestTypeEnum = "AppriseRequestTestTypeEnum",
	AssignedToPatientThroughEnum = "AssignedToPatientThroughEnum",
	AuthorizationTypeEnum = "AuthorizationTypeEnum",
	BenefitTypeEnum = "BenefitTypeEnum",
	BusinessCentralApiCallTypeEnum = "BusinessCentralApiCallTypeEnum",
	BusinessCentralAuthenticationTypeEnum = "BusinessCentralAuthenticationTypeEnum",
	ClaimBatchStatusEnum = "ClaimBatchStatusEnum",
	ClaimBox1PlanTypeEnum = "ClaimBox1PlanTypeEnum",
	ClaimCreationStatusEnum = "ClaimCreationStatusEnum",
	ClaimExcelTokenEnum = "ClaimExcelTokenEnum",
	ClaimInsurancePlanRankEnum = "ClaimInsurancePlanRankEnum",
	ClaimInsurancePlanTypeEnum = "ClaimInsurancePlanTypeEnum",
	ClaimInsuredBenefitAssignmentCertificationEnum = "ClaimInsuredBenefitAssignmentCertificationEnum",
	ClaimInsuredProviderAcceptAssignmentEnum = "ClaimInsuredProviderAcceptAssignmentEnum",
	ClaimInsuredReleaseInformationCodeEnum = "ClaimInsuredReleaseInformationCodeEnum",
	ClaimInsuredSubmitterTypeEnum = "ClaimInsuredSubmitterTypeEnum",
	ClaimProcessingExecuteSourceTypeEnum = "ClaimProcessingExecuteSourceTypeEnum",
	ClaimsGroupFilterEnum = "ClaimsGroupFilterEnum",
	ClaimStatusEnum = "ClaimStatusEnum",
	ClaimUnbundleCodeActionEnum = "ClaimUnbundleCodeActionEnum",
	CommonReportTypeEnum = "CommonReportTypeEnum",
	CommunicationSourceEnum = "CommunicationSourceEnum",
	DefaultPageEnum = "DefaultPageEnum",
	DispensingPlanModeEnum = "DispensingPlanModeEnum",
	DocumentTemplateEmailSourceEnum = "DocumentTemplateEmailSourceEnum",
	DocumentTemplateTypeEnum = "DocumentTemplateTypeEnum",
	DocumentTypeGroupEnum = "DocumentTypeGroupEnum",
	EarSetupTypeEnum = "EarSetupTypeEnum",
	EarSideEnum = "EarSideEnum",
	EarSideExtendedUnspecifiedEnum = "EarSideExtendedUnspecifiedEnum",
	EdiModeEnum = "EdiModeEnum",
	EligibilityRequestTypeEnum = "EligibilityRequestTypeEnum",
	EndOfDayStatusEnum = "EndOfDayStatusEnum",
	ErpSystemEnum = "ErpSystemEnum",
	HistoryRecordStateEnum = "HistoryRecordStateEnum",
	IcdCodePositionEnum = "IcdCodePositionEnum",
	ImmMidEarEvalTympEnum = "ImmMidEarEvalTympEnum",
	ImmMidEarReflexEnum = "ImmMidEarReflexEnum",
	ImportCsvFileDelimiterEnum = "ImportCsvFileDelimiterEnum",
	ImportEntityTypeEnum = "ImportEntityTypeEnum",
	ImportValueErrorEnum = "ImportValueErrorEnum",
	InsurancePlanFilingMethodEnum = "InsurancePlanFilingMethodEnum",
	InsurancePriorityEnum = "InsurancePriorityEnum",
	InsuranceProductTypeEnum = "InsuranceProductTypeEnum",
	InventoryOrderLineStatusEnum = "InventoryOrderLineStatusEnum",
	InventoryOrderStatusEnum = "InventoryOrderStatusEnum",
	InventoryOrderTypeEnum = "InventoryOrderTypeEnum",
	LicensePlanTypeEnum = "LicensePlanTypeEnum",
	LookupTypeEnum = "LookupTypeEnum",
	LossAndDamageOptionEnum = "LossAndDamageOptionEnum",
	MedicalReportBinauralDiscriminationEnum = "MedicalReportBinauralDiscriminationEnum",
	MedicalReportConfirmationEnum = "MedicalReportConfirmationEnum",
	MedicalReportLevelEnum = "MedicalReportLevelEnum",
	MedicalReportOutcomEnum = "MedicalReportOutcomEnum",
	MedicalReportRecommendationEnum = "MedicalReportRecommendationEnum",
	MedicalReportReturnEnum = "MedicalReportReturnEnum",
	MemberIdRequiredTypeEnum = "MemberIdRequiredTypeEnum",
	MemberIdFormatEnum = "MemberIdFormatEnum",
	NoteStatusEnum = "NoteStatusEnum",
	NoteTypeEnum = "NoteTypeEnum",
	OrderLineStatusEnum = "OrderLineStatusEnum",
	OrderStatusEnum = "OrderStatusEnum",
	PatientAlertStatusEnum = "PatientAlertStatusEnum",
	PatientDocumentStatusEnum = "PatientDocumentStatusEnum",
	PatientInsuranceCodeTypeEnum = "PatientInsuranceCodeTypeEnum",
	PatientOrderStatusEnum = "PatientOrderStatusEnum",
	PatientPreferredContactEnum = "PatientPreferredContactEnum",
	PatientReferringPhysicianPriorityEnum = "PatientReferringPhysicianPriorityEnum",
	PatientSatisfactionEnum = "PatientSatisfactionEnum",
	PatientStatusEnum = "PatientStatusEnum",
	PaymentMethodEnum = "PaymentMethodEnum",
	TransactionTypeEnum = "TransactionTypeEnum",
	EntryModeIdEnum = "EntryModeIdEnum",
	PaymentTypeEnum = "PaymentTypeEnum",
	PaymentStatusEnum = "PaymentStatusEnum",
	ProcessingInfoEvent = "ProcessingInfoEvent",
	ProcessingInfoMessageType = "ProcessingInfoMessageType",
	ProductBundleTypeEnum = "ProductBundleTypeEnum",
  	ProductCategoryRankEnum = "ProductCategoryRankEnum",
  	RepairTypeEnum = "RepairTypeEnum",
	ProductKitTypeEnum = "ProductKitTypeEnum",
	ProductStyleSideEnum = "ProductStyleSideEnum",
	PureToneCategoryEnum = "PureToneCategoryEnum",
	PureToneDegreeEnum = "PureToneDegreeEnum",
	PureToneFrequencyModifierEnum = "PureToneFrequencyModifierEnum",
	PureToneStimulusMethodEnum = "PureToneStimulusMethodEnum",
	PurposeOfVisitEnum = "PurposeOfVisitEnum",
	QueueStatusEnum = "QueueStatusEnum",
	RecallStatusEnum = "RecallStatusEnum",
	RecommendationDurationEnum = "RecommendationDurationEnum",
	RecommendationEquilibriumType = "RecommendationEquilibriumType",
	RecommendationSideEnum = "RecommendationSideEnum",
	RepairLocationEnum = "RepairLocationEnum",
	ReportTypeEnum = "ReportTypeEnum",
	RequestSourceEnum = "RequestSourceEnum",
	ReturnOrderLineOptionEnum = "ReturnOrderLineOptionEnum",
	SACLevelEnum = "SACLevelEnum",
	SalesOrderClaimProcessingStatusEnum = "SalesOrderClaimProcessingStatusEnum",
	SalesOrderInventoryStatusEnum = "SalesOrderInventoryStatusEnum",
	SalesOrderSearchSourceFilterEnum = "SalesOrderSearchSourceFilterEnum",
	SalesOrderSearchTypeFilterEnum = "SalesOrderSearchTypeFilterEnum",
	SalesPersonModeEnum = "SalesPersonModeEnum",
  	SchedulingClaimFrequencyEnum = "SchedulingClaimFrequencyEnum",
  	SchedulerDefaultViewEnum = "SchedulerDefaultViewEnum",
	SerializedItemStatusEnum = "SerializedItemStatusEnum",
	ServiceCategoryEnum = "ServiceCategoryEnum",
	ServiceStatusEnum = "ServiceStatusEnum",
	ServiceTypeEnum = "ServiceTypeEnum",
	SpeechSATEnum = "SpeechSATEnum",
	SpeechSRTEnum = "SpeechSRTEnum",
	SpeechWordRecognitionEnum = "SpeechWordRecognitionEnum",
	SsrsReportFilterTypeEnum = "SsrsReportFilterTypeEnum",
	StateAdministrativeLevelEnum = "StateAdministrativeLevelEnum",
	SubmitterTypeEnum = "SubmitterTypeEnum",
	TaxIdTypeEnum = "TaxIdTypeEnum",
	TemplateSlotTypeEnum = "TemplateSlotTypeEnum",
	TimeSlotTypeEnum = "TimeSlotTypeEnum",
	TokenConditionEnum = "TokenConditionEnum",
	UnavailableSlotApplyToTypeEnum = "UnavailableSlotApplyToTypeEnum",
	UnitWeightBasisEnum = "UnitWeightBasisEnum",
	WarrantyPriorityEnum = "WarrantyPriorityEnum",
	WorkerJobEnum = "WorkerJobEnum",
  	WorkQueueTypeEnum = "WorkQueueTypeEnum",
  	TaxModeEnum = "TaxModeEnum",
	IntegrationStatusEnum = "IntegrationStatusEnum",
	ExternalApiCallTypeEnum = "ExternalApiCallTypeEnum",
	ServicePlanPriorityEnum = "ServicePlanPriorityEnum",
	SqlTaskStatusEnum = "SqlTaskStatusEnum",
  	CreditCardPayEnum ="CreditCardPayEnum",
	ADPPersonEnum = "ADPPersonEnum",
	EndOfDayEnforceUserPriorityEnum = "EndOfDayEnforceUserPriorityEnum",
	ThirdPartyEnum = "ThirdPartyEnum",
	ThirdPartyPartnerApiCallTypeEnum = "ThirdPartyPartnerApiCallTypeEnum"
}
